import { Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild, } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DepotService, AssetTypeClassification, LocationTypeDto, CurrentAssetLocationDto, CustomerLocationDto, ContainerAvailabilityService, ContainerAvailabilityResponse, ContainerStatus, ContainerAvailabilityShow, DepotAvailabilityType } from 'src/shared/service-proxies/service-proxies';
import { PageHelperService } from '../helpers/page-helper.service';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import moment from 'moment';
import { SessionStorageService } from '../services/session-storage.service';
import { Router } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { VehicleTypeHelper } from '../helpers/VehicleTypeHelper';
import { LocalStorageService } from '../services/local-storage.service';
import { CustomerSettings } from '../services/customer-settings-service';
import { Observable, of } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import * as L from 'leaflet';
import * as R from 'leaflet-responsive-popup';
import { forEach } from '@angular-devkit/schematics';
import { AuthService } from '../security/auth.service';
import { SummaryDataItemModel } from '../models/summary-data-item-model';
import { GeoHelper } from '../helpers/geo';
import { LocationClassNameHelper } from '../enums/LocationTypeNames';

export class DropDownListItem {
  constructor(id?: string, name?: string) {
    this.id = id,
    this.name = name;
  }

  id: string;
  name: string;
}

export enum DamageStatus {
  None = 0,
  InService = 1,
  Damaged = 2,
  DamagedInService = 3
}

export enum ShowSetting {
  All = 0,
  Surplus = 1,
  Deficit = 2
}

@Component({
    selector: 'app-container-availability-component',
    templateUrl: './container-availability.component.html',
    styleUrls: ['./container-availability.component.scss'],
    standalone: false
})
export class ContainerAvailabilityComponent extends PagebaseComponent implements OnDestroy, OnInit {
  @Input() depotId!: string;
  @Input() locationId!: string;
  @ViewChild('mapdiv')
  mapDiv: ElementRef;
    
  // Private variables
  customerId: string;
  data: ContainerAvailabilityResponse;
  regionList: DropDownListItem[];
  allDepots: DropDownListItem[];
  depotList: DropDownListItem[];
  locationList: DropDownListItem[];
  selectedRegionId: string;
  selectedDepotId: string;
  selectedLocationId: string;
  selectedVehicleType: string;
  selectedDamageStatus: string;
  selectedShowSetting: string;
  assetTypeSearchControl: UntypedFormControl = new UntypedFormControl();
  expandedCategories: string[] = [];
  searchControl: UntypedFormControl = new UntypedFormControl();
  viewModeForm = new UntypedFormGroup({
    viewMode: new UntypedFormControl('both')
  });
  showMode: string = "both";
  locationTypes: LocationTypeDto[];
  locationTypesDisplay: LocationTypeDto[] = [];  
  mapZoomLevel: number;
  summaryData = [];
  locations: CustomerLocationDto[];
  assets: CurrentAssetLocationDto[];
  totalDepot: number = 0;
  totalYard: number = 0;
  totalDamaged: number = 0;
  totalAvailable: number = 0;
  totalRequired: number = 0;
  totalSurplus: number = 0;
  totalDeficit: number = 0;
  totalNetSurplus: number = 0;
  compareDate = new UntypedFormControl(new Date());
  private apiCall;

  // Public variables
  loading: boolean = true;
  DamageStatus = DamageStatus;
  ShowSetting = ShowSetting;

  // Map
  private map;
  private mapLayer = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&key=AIzaSyChxd9LP-pHKK1qe1nPlECcK5iJb-a4hg8', {
      maxZoom: 18,
      minZoom: 3,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
  });
  private drawLayer = L.layerGroup();
  
  // Constuctor
  constructor(
    private _depotService: DepotService,
    private _containerAvailabilityService: ContainerAvailabilityService,
    private sessionStorageService: SessionStorageService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private customerSettings: CustomerSettings,
    private authService: AuthService,
    pageHelperService: PageHelperService,
    applicationStatusService: ApplicationStatusService
    ) {
    super(pageHelperService, applicationStatusService, customerSettings, "Container Availability");
  }

  ngOnInit() {
    this.localStorageService.setItem("container-availability-selectedCompareDate", JSON.stringify(new Date()));
    this.summaryData = this.getLoadingSummarries();
    this.previewMap()
  }

  ngOnDestroy(): void {
    if (this.map ){
      this.map.eachLayer(function(layer){
          layer.remove();
      });
      this.map.remove();
      this.map = null;
      this.mapDiv.nativeElement.innerHTML = "";
    }
  }

  getLoadingSummarries() : SummaryDataItemModel[] {
    var items = [];
    var text = "";
    text = text.concat("\xa0");
    let blank: SummaryDataItemModel = {
      Title: text,
      Value: text
    };
    items.push(blank);
    items.push(blank);
    items.push(blank);
    items.push(blank);
    return items;
  }

  private previewMap() {
    if (!this.map) {
      this.map = L.map('map', {
        center: [ 54.276050, -2.654715 ],
        zoom: 6,
        scrollWheelZoom: false
      });

      this.mapLayer.addTo(this.map);
      this.drawLayer.addTo(this.map);
      setTimeout(() => {
        this.map.invalidateSize(true);
      }, 100)
    }
  }  

  unsubscribe() { 
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
  }

  reset() {
    this.data = null;
    this.locations = [];
    this.assets = [];
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
  }

  // Get the view data
  getData(recentreMap: boolean) {
    this.data = null;

    if (this.depotId) {
      this.sessionStorageService.setItem("container-availability-selectedDepotId", this.depotId);
      this.sessionStorageService.removeItem("container-availability-selectedRegionId");
      this.sessionStorageService.removeItem("container-availability-selectedLocationId");
      this.sessionStorageService.removeItem("container-availability-selectedDamageStatus");
      this.sessionStorageService.removeItem("container-availability-selectedShowSetting");
      this.depotId = null;
    }

    if (this.locationId) {
      this.sessionStorageService.setItem("container-availability-selectedLocationId", this.locationId);
      this.locationId = null;
    }

    let selectedRegionId = this.sessionStorageService.getItem("container-availability-selectedRegionId");
    if(selectedRegionId) {
      this.selectedRegionId = selectedRegionId;
    }
    else {
      this.selectedRegionId = null;
    }
    let selectedDepotId = this.sessionStorageService.getItem("container-availability-selectedDepotId");
    if(selectedDepotId) {
      this.selectedDepotId = selectedDepotId;
    }
    else {
      this.selectedDepotId = null;
    }
    let selectedLocationId = this.sessionStorageService.getItem("container-availability-selectedLocationId");
    if(selectedLocationId) {
      this.selectedLocationId = selectedLocationId;
    }
    else {
      this.selectedLocationId = null;
    }
    let selectedVehicleType = this.sessionStorageService.getItem("dashboard-active-selectedVehicleType");
    if(selectedVehicleType) {
      selectedVehicleType = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleType"));
      this.selectedVehicleType = selectedVehicleType;
    }
    let selectedDamageStatus = this.sessionStorageService.getItem("container-availability-selectedDamageStatus");
    if(selectedDamageStatus) {
      this.selectedDamageStatus = selectedDamageStatus;
    }    
    let selectedShowSetting = this.sessionStorageService.getItem("container-availability-selectedShowSetting");
    if(selectedShowSetting) {
      this.selectedShowSetting = selectedShowSetting;
    }
    let selectedCompareDate = this.localStorageService.getItem("container-availability-selectedCompareDate");
    if(selectedCompareDate) {
      selectedCompareDate = JSON.parse(selectedCompareDate);
      this.compareDate = new UntypedFormControl(selectedCompareDate);
    }

    if(this.customerId != this.pageHelperService.selectedCompanyId) {
      console.log("loading regions & depots");
      this.loading = true;
      this.setIsLoading(this.loading);

      this.customerId = this.pageHelperService.selectedCompanyId;
      this._depotService.getRegions(this.pageHelperService.selectedCompanyId).subscribe(data => {
        const regionList: DropDownListItem[] = [];
        data.forEach(region => {
          let regionItem = new DropDownListItem()
          regionItem.id = region.id;
          regionItem.name = region.name;
          regionList.push(regionItem)
        });
        
        this.regionList = regionList;
        this._depotService.getUserDepots(this.pageHelperService.selectedCompanyId).subscribe(data => {    
          const depotList: DropDownListItem[] = [];
          data.forEach(depot => {
            let depotItem = new DropDownListItem()
            depotItem.id = depot.id;
            depotItem.name = depot.name;
            depotList.push(depotItem)
          });
          
          this.allDepots = depotList;
          this.depotList = depotList;
          this.loading = false;
          this.setIsLoading(this.loading);
        });
      });
    }

    console.log("loading data");
    this.loading = true;
    this.setIsLoading(this.loading);

    this.apiCall = this._containerAvailabilityService
      .getContainerAvailability(
        this.customerId,
        this.getRegionId(selectedRegionId),
        this.getDepotId(selectedDepotId),
        this.getLocationId(selectedLocationId),
        this.getDamageStatus(selectedDamageStatus),
        this.getShowSetting(selectedShowSetting),
        this.getAssetTypeClassification(selectedVehicleType),
        this.getCompareDate(selectedCompareDate),
        selectedRegionId ? true : false)
      .subscribe(data => {
        this.data = data;

        if (this.data.regionDepotIds && this.data.regionDepotIds.length > 0) {
          this.depotList = this.allDepots.filter(item => this.data.regionDepotIds.includes(item.id));
        }
        else {
          this.depotList = this.allDepots;
        }
        this.assets = data.assets;
        this.locations = data.locations;
        this.locationList = this.locations.map(l => <DropDownListItem>{ id: l.id, name: l.displayName });
        this.locationTypes = data.locationTypes;
        this.initMap();
        this.showAssets(recentreMap);        
        this.loading = false;
        this.setIsLoading(this.loading);
      }, error => {
        debugger;
      });
  }

  viewModeChange(e) {
    this.showMode = e.target.value;
    const map = this.map;
    setTimeout(function(){ map.invalidateSize() }, 400);
  }

  private initMap(): void {
    let allLatLons = [];

    this.locations.forEach(location => {
      allLatLons.push({ lat: location.latitude, lon: location.longitude })
    });
    
    let centre = GeoHelper.GetCenterFromPositions(allLatLons);
    
    if (!this.map) {
      let zoom = GeoHelper.CalculateZoom(allLatLons, this.mapDiv.nativeElement.offsetHeight, this.mapDiv.nativeElement.offsetWidth);
      this.map = L.map('map', {
        center: [ centre.lat, centre.lon ],
        zoom: zoom,
        scrollWheelZoom: false
      });

      this.mapLayer.addTo(this.map);
      this.drawLayer.addTo(this.map);
      setTimeout(() => {
        this.map.invalidateSize(true);
      }, 1)
    } else {
      try {
        this.map.flyTo(new L.LatLng(centre.lat, centre.lon), 15, {
          animate: true,
          duration: 1.5
        });
      }
      catch {}
    }
    let ctrl = this;
    this.map.on('zoomend', function() {
      if (ctrl.mapZoomLevel != ctrl.map.getZoom()) {
        ctrl.mapZoomLevel = ctrl.map.getZoom();
        
        ctrl.showAssets(false);
      }
    });

    this.drawLocations(null, true)
  }

  drawLocations(assets: CurrentAssetLocationDto[], recentreMap: boolean) {
    let allLatLons = [];
    this.map.removeLayer(this.drawLayer);
    this.drawLayer = L.layerGroup();
    this.drawLayer.addTo(this.map);
    const locationTypesDisplay = []
    
    this.locations.forEach(location => {
      if (assets == null || assets.some(a => a.locationId == location.id)) {
        allLatLons.push({ lat: location.latitude, lon: location.longitude })
      }
    });

    if (recentreMap && this.showMode != "table") {
      let centre = GeoHelper.GetCenterFromPositions(allLatLons);

      if (Number.isNaN(centre.lat) && Number.isNaN(centre.lon)) {
        centre.lat = 54.003645;
        centre.lon = -2.547858;
      }

      if (!centre.lat) {
          centre.lat = 0;
      }

      if (!centre.lon) {
        centre.lon = 0;
      }

      let zoom = GeoHelper.CalculateZoom(allLatLons, this.mapDiv.nativeElement.offsetHeight, this.mapDiv.nativeElement.offsetWidth);
      zoom = allLatLons.length == 1 ? 12 : zoom;

      if (!zoom) {
        zoom = 7
      }

      this.mapZoomLevel = zoom;
      this.map.flyTo(new L.LatLng(centre.lat, centre.lon), zoom, {
        animate: true,
        duration: 1.5
      });
    }

    this.locations.forEach(location => {
      let locationBins = this.getBinsAtLocation(location.id);
      if (assets == null || assets.some(a => a.locationId == location.id)) {
        this.addLocationPin(location.id, location.locationType, location.displayName, location.summary, location.latitude, location.longitude, locationBins);

        if (!locationTypesDisplay.find(l => l.name == location.locationType)) {
          var locationTypeNameDisplay = this.locationTypes.find(lt => lt.name == location.locationType);
          locationTypesDisplay.push(locationTypeNameDisplay)
        }
      }
    });
    
    this.locationTypesDisplay = locationTypesDisplay;
  }

  addLocationPin(locationId, locationTypeName, locationName, locationSummary, locationLatitude, locationLongitude, locationBins: CurrentAssetLocationDto[]) {
    let pinColour = locationTypeName == null ? "vehicle" : LocationClassNameHelper.getLocationColour(locationTypeName);
    
    let radius = this.getLocationRadius(this.mapZoomLevel);
    
    const sum = locationBins.map(b => b.daysAtLocation).reduce((a, b) => a + b, 0);
    const avg = Math.round((sum / locationBins.length) || 0);

    let popupContent = '<p>' + `${locationName}<br><br>${locationSummary}` +'</p>';
    const popup = R.responsivePopup({ hasTip: false, autoPan: false, offset: [20, 20]}).setContent(popupContent);
    let marker = L.circle([locationLatitude, locationLongitude], { 
      radius: radius,
      color: "black",
      weight: 1,
      fillColor: pinColour,
      fillOpacity: 1,
     }).addTo(this.drawLayer);
    let showTip = function() {
      this.unbindTooltip();
      if(!this.isPopupOpen()) this.bindPopup(popup, { minWidth: 280}).openPopup();
    }
    
    let hideTip = function() {
      this.unbindTooltip();
      if(this.isPopupOpen()) this.closePopup();
    }
    
    let router = this.router;
    let commands = this.getLocationNavigationCommands(locationId);
    let goToRoute = function() {
      router.navigate(commands);
    }

    marker.on('mouseover', showTip);
    marker.on('mouseout', hideTip);
    marker.on('click', goToRoute);
  }

  getLocationRadius(zoom: number) {
    switch(zoom) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
        return 5000;
      case 7:
        return 4000;
      case 8:
        return 2500;
      case 9:
        return 1500;
      case 10:
        return 900;
      case 11: 
        return 600;
      case 12:
        return 400;
      case 13:
        return 300;
      case 14:
        return 200;
      case 15:
        return 100;
      case 16:
        return 60;
      case 17:
        return 40;
      default:
        return 20;
    }
  }

  getBinsAtLocation(locationId: string) : CurrentAssetLocationDto[]{
    if (!this.assets) {
      return [];
    }

    return this.assets.filter(a => a.locationId == locationId);
  }

  getLocation(locationId: string) : CustomerLocationDto{
    return this.locations.find(a => a.id == locationId);
  }

  showAssets(recentreMap: boolean) {
    let selectedAssetLocationTypeId = this.sessionStorageService.getItem("container-availability-selectedAssetLocationTypeId");
    let selectedRegionId = this.sessionStorageService.getItem("container-availability-selectedRegionId");
    if(selectedRegionId) {
      this.selectedRegionId = selectedRegionId;
    }    
    let selectedDepotId = this.sessionStorageService.getItem("container-availability-selectedDepotId");
    if(selectedDepotId) {
      this.selectedDepotId = selectedDepotId;
    }
    let selectedVehicleType = this.sessionStorageService.getItem("dashboard-active-selectedVehicleType");
    if(selectedVehicleType) {
      selectedVehicleType = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleType"));
      this.selectedVehicleType = selectedVehicleType;
    }

    this.totalDepot = this.data.depotTotal;
    this.totalYard = this.data.yardTotal;
    this.totalDamaged = this.data.damagedTotal;
    this.totalAvailable = this.data.availableTotal;
    this.totalRequired = this.data.netRequiredTotal;
    this.totalSurplus = this.data.surplusTotal;
    this.totalDeficit = this.data.deficitTotal;
    this.totalNetSurplus = this.data.netSurplusTotal;

    this.drawLocations(this.assets, recentreMap);
    this.summaryData = this.getSummaryData();
  }

  getSummaryData(): SummaryDataItemModel[] {
    let items = [];

    let depot: SummaryDataItemModel = {
      Title: "Depot",
      Value: this.totalDepot.toString()
    };
    items.push(depot);

    let yard: SummaryDataItemModel = {
      Title: "Yard",
      Value: this.totalYard.toString()
    };
    items.push(yard);

    let damaged: SummaryDataItemModel = {
      Title: "Damaged",
      Value: this.totalDamaged.toString()
    };
    items.push(damaged);

    let available: SummaryDataItemModel = {
      Title: "Available",
      Value: this.totalAvailable.toString()
    };
    items.push(available);

    if (!this.selectedDamageStatus) {
      let required: SummaryDataItemModel = {
        Title: "Required",
        Value: this.totalRequired.toString()
      };
      items.push(required);
  
      let netSurplus: SummaryDataItemModel = {
        Title: "Surplus",
        Value: this.totalNetSurplus.toString()
      };
      items.push(netSurplus);
    }

    return items;
  }  

  getRegionId(selectedRegionId) {
    if (!selectedRegionId) {
      return null;
    }

    return selectedRegionId;
  }

  getDepotId(selectedDepotId) {
    if (!selectedDepotId) {
      return null;
    }

    return selectedDepotId;
  }

  getLocationId(selectedLocationId) {
    if (!selectedLocationId) {
      return null;
    }

    return selectedLocationId;
  }

  getDamageStatus(selectedDamageStatus: string) {
    return null;
    /*
    if (!selectedDamageStatus) {
      return null;
    }

    if (selectedDamageStatus == DamageStatus[DamageStatus.Damaged]) {
      return ContainerStatus.Damaged;
    }

    if (selectedDamageStatus == DamageStatus[DamageStatus.DamagedInService]) {
      return ContainerStatus.DamagedInService;
    }

    return ContainerStatus.InService;
    */
  }

  getShowSetting(selectedShowSetting: string) {
    if (!selectedShowSetting) {
      return ContainerAvailabilityShow.All;
    }

    if (selectedShowSetting == ShowSetting[ShowSetting.Surplus]) {
      return ContainerAvailabilityShow.Surplus;
    }

    return ContainerAvailabilityShow.Deficit;
  }  

  getAssetTypeClassification(selectedVehicleType: string) {
    return !selectedVehicleType ? AssetTypeClassification.All : VehicleTypeHelper.ConvertVehicleTypeNameToAssetTypeClassification(selectedVehicleType)
  }

  getCompareDate(selectedCompareDate: string) {
    if (!selectedCompareDate) {
      return null;
    }

    return moment(selectedCompareDate);
  }

  getMinCompareDate() {
    let date = new Date();

    date.setDate(date.getDate() - 366)

    return date;
  }

  getMaxCompareDate() {
    let date = new Date();

    return date;
  }

  regionChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("container-availability-selectedRegionId", newValue);
    }
    else {
      this.sessionStorageService.removeItem("container-availability-selectedRegionId");
    }

    this.selectedDepotId = null;
    this.sessionStorageService.removeItem("container-availability-selectedDepotId");    
    this.getData(true);
  }

  depotChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("container-availability-selectedDepotId", newValue);
    }
    else {
      this.sessionStorageService.removeItem("container-availability-selectedDepotId");
    }

    this.getData(true);
  }

 locationChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("container-availability-selectedLocationId", newValue);
    }
    else {
      this.sessionStorageService.removeItem("container-availability-selectedLocationId");
    }

    this.getData(true);
  }

  damageStatusChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("container-availability-selectedDamageStatus", newValue);
    }
    else {
      this.sessionStorageService.removeItem("container-availability-selectedDamageStatus")
    }

    this.getData(true);
  }

 showSettingChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("container-availability-selectedShowSetting", newValue);
    }
    else {
      this.sessionStorageService.removeItem("container-availability-selectedShowSetting")
    }

    this.damageStatusChange("");
  }  


  selectedVehicleTypeValueChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("dashboard-active-selectedVehicleType", JSON.stringify(newValue));
    }
    else {
      this.sessionStorageService.removeItem("dashboard-active-selectedVehicleType");
    }
    
    this.selectedVehicleType = newValue;
    this.getData(true);    
  }

  toggleRow(category) {
    if (this.expandedCategories.includes(category)) {
      const index = this.expandedCategories.indexOf(category);
      if (index > -1) {
        this.expandedCategories.splice(index, 1);
      }
    } else {
      this.expandedCategories.push(category);
    }
  }

  getAssetType(assetTypes: DepotAvailabilityType[], name: string) {
    return assetTypes.find(t => t.name === name);
  }

  goToLocation(locationId: string) {
    this.router.navigate(this.getLocationNavigationCommands(locationId));
  }

  getLocationNavigationCommands(locationId: string): any[]{
    let location = this.locations.find(l => l.id == locationId);

    if (location) {
      let depotId = location.depotId;
      
      return ['/depot-details', {depotId: depotId, locationId: locationId}];
    }

    return ['/container-availability'];
  }

  dateFilterChanged(newValue : Date) {
    if (newValue) {
      this.localStorageService.setItem("container-availability-selectedCompareDate", JSON.stringify(newValue));
    }
    else {
      this.localStorageService.removeItem("container-availability-selectedCompareDate")
    }

    this.getData(false);
  }
}